// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expand-btn {
    cursor: pointer;
    text-decoration: none;
    display: flex;
    align-items: center;
    color: rgb(95, 33, 32)
}

.expand-btn:hover {
    color: rgb(95, 33, 32);
    font-weight: bold;
    text-decoration: none;
}

.keyboard-down-icon {
    transition: transform 0.4s !important;
}
  
.rotated {
    transform: rotate(180deg);
}

.expandable-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease; /* Adjust the duration and easing function as needed */
}
  
.expandable-content-visible {
    max-height: 200px;
}
  
.expandable-content-hidden {
    max-height: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/BasicAlert/BasicAlert.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gCAAgC,EAAE,sDAAsD;AAC5F;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".expand-btn {\n    cursor: pointer;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    color: rgb(95, 33, 32)\n}\n\n.expand-btn:hover {\n    color: rgb(95, 33, 32);\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.keyboard-down-icon {\n    transition: transform 0.4s !important;\n}\n  \n.rotated {\n    transform: rotate(180deg);\n}\n\n.expandable-content {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.5s ease; /* Adjust the duration and easing function as needed */\n}\n  \n.expandable-content-visible {\n    max-height: 200px;\n}\n  \n.expandable-content-hidden {\n    max-height: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
